import {
  FaAngleLeft,
  FaAngleRight,
} from "react-icons/fa";

export const AbsoluteNextArrow = ({ onClick }) => (
  <button
    className="absolute z-10 p-2 text-white transform -translate-y-1/2 rounded-full shadow-md right-5 bg-primaryDark top-1/2 hover:bg-primaryLight md:p-2"
    onClick={onClick}
  >
    <FaAngleRight className="text-lg" />
  </button>
);

export const AbsolutePrevArrow = ({ onClick }) => (
  <button
    className="absolute z-10 p-2 text-white transform -translate-y-1/2 rounded-full shadow-md left-5 bg-primaryDark top-1/2 hover:bg-primaryLight md:p-2"
    onClick={onClick}
  >
    <FaAngleLeft className="text-lg" />
  </button>
);
export const NextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="h-[35px] w-[35px] rounded-full bg-primaryDark border flex justify-center items-center"
  >
    <FaAngleLeft />
  </button>
);
export const PrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="h-[35px] w-[35px] rounded-full bg-primaryDark border flex justify-center items-center"
  >
    <FaAngleLeft />
  </button>
);
